'use strict';

module.exports = require('es5-ext/object/primitive-set')('key',
	'value', 'key+value');



//////////////////
// WEBPACK FOOTER
// ../node_modules/es6-map/lib/iterator-kinds.js
// module id = 1355
// module chunks = 0